import { get, map, isEmpty, find } from 'lodash-es';
import uuidv4 from 'uuid/v4';
import { checkIsEmpty } from '../../utils';

/**
 * get question
 * @param extraData
 */
const getQuestionGroup = extraData => ({
  code: get(extraData, 'code'),
  sequence: get(extraData, 'sequence'),
});

const handleQuestionGroup = group => {
  // from web service
  if (!isEmpty(get(group, 'extra_data'))) {
    return map(get(group, 'extra_data'), extraData => getQuestionGroup(extraData));
  }
  // from store
  if (!isEmpty(get(group, 'questions'))) {
    return map(get(group, 'questions'), question => getQuestionGroup(question));
  }
  return undefined;
};

/**
 * get group
 * @param group
 */
const getGroup = group => ({
  ...group,
  id: !checkIsEmpty(get(group, 'id')) ? get(group, 'id') : uuidv4(),
  title: { default: group?.title },
  questions: handleQuestionGroup(group),
  // todo verify reel case
  groups: !isEmpty(get(group, 'groups')) ? map(get(group, 'groups'), groupItem => getGroup(groupItem)) : undefined,
});

/**
 * get question
 * @param {*} question
 */
const getQuestion = (question, answerValue) => {
  try {
    const validation = !isEmpty(get(question, 'validation'))
      ? get(question, 'validation')
      : [{ required: true, message: ' ' /* 'champ obligatoire' */ }]; // HACK demo to not display error message
    const result = {
      ...question,
      value: answerValue,
      validation,
    };
    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getPart ${e.stack}`);
  }
  return undefined;
};

/**
 * get answer value
 * @param {} answersQuestion
 * @param {*} code
 */
const getAnswerValue = (answersQuestion, code) => get(answersQuestion, code);

/**
 * get part
 * @param part
 */
const getPart = (part, answersQuestion) => {
  try {
    const questions = map(get(part, 'questions'), questionItem => {
      const question = getQuestion(questionItem, getAnswerValue(answersQuestion, get(questionItem, 'code')));
      return question;
    });
    const groups = !isEmpty(get(part, 'groups')) ? map(get(part, 'groups'), group => getGroup(group)) : undefined;
    const result = {
      ...part,
      title: { default: part.title },
      questions,
      groups,
    };
    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getPart ${e.stack}`);
  }
  return undefined;
};

/**
 *
 * @param {*} answersParts
 * @param {*} part
 */
const getAnswersQuestions = (part, answersParts) => {
  try {
    const answersPart = find(answersParts, { id: get(part, 'id') });
    const answersQuestions = get(answersPart, 'answers');
    return answersQuestions;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getAnswersQuestions ${e.stack}`);
  }
  return undefined;
};

/**
 * get questionnaire
 * @param questionnaire
 */
const getQuestionnaire = (questionnaire, answersParts = undefined) => {
  try {
    const parts = map(get(questionnaire, 'parts'), partItem => {
      const answersQuestions = answersParts ? getAnswersQuestions(partItem, answersParts) : undefined;
      const part = getPart(partItem, answersQuestions);
      return part;
    });
    const result = {
      id: get(questionnaire, 'id'),
      code: get(questionnaire, 'code'),
      icon: get(questionnaire, 'icon_name'),
      title: get(questionnaire, 'title'),
      descriptions: get(questionnaire, 'descriptions'),
      sequence: get(questionnaire, 'sequence'),
      parts,
    };
    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getQuestionnaire ${e.stack}`);
  }
  return undefined;
};

/**
 *  get answers questionnaire
 * @param {*} questionnaire
 */
const getAnswersQuestionnaire = questionnaire => {
  try {
    const questionnaireId = get(questionnaire, 'questionnaire.id');
    const parts = map(get(questionnaire, 'parts'), partItem => ({
      id: get(partItem, 'id'),
      answers: get(partItem, 'answers'),
    }));
    // check answers parts is empty
    if (isEmpty(parts)) {
      return undefined;
    }
    const answersQuestionnaire = {
      id: questionnaireId,
      parts,
    };
    return answersQuestionnaire;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  return undefined;
};

/**
 * questionnaire Block Ready
 * @param {*} param0
 */
const questionnaireBlockIsReady = ({ questionnaire }) => {
  try {
    const isReady = !isEmpty(get(questionnaire, 'parts[0].questions'));
    return isReady;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`questionnaireBlockIsReady ${e.stack}`);
  }
  return false;
};

/**
 *
 * @param {*} param0
 */
const questionnaireBlockTransform = ({ salesRoute, questionnaires }) => {
  try {
    const idQuestionnaire = get(salesRoute, 'questionnaires[0].questionnaire.id');
    const answersQuestionnaire = getAnswersQuestionnaire(get(salesRoute, 'questionnaires[0]'));
    const questionnaire = find(questionnaires, { id: idQuestionnaire });
    const checkQuestionnaireHasAnswers = !isEmpty(get(answersQuestionnaire, 'parts'));

    const isReady = questionnaireBlockIsReady({ questionnaire });

    if (!isReady) {
      // eslint-disable-next-line no-console
      return {};
    }

    // build block questionnaire
    const blockQuestionnaire = getQuestionnaire(
      questionnaire,
      checkQuestionnaireHasAnswers ? get(answersQuestionnaire, 'parts') : undefined
    );

    return blockQuestionnaire;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`questionnaireBlockTransform: ${e.stack}`);
  }
  return {};
};

export default questionnaireBlockTransform;
